import React, { useState } from 'react'
import { Modal, Typography } from 'antd'
import { ComponentView } from 'components/common/componentView'
import { useAuthSelector } from 'store/authSlice/authReducer'
import { CopyBlock, dracula } from 'react-code-blocks'
import { getVolunteerLandingPageUrl, htmlCode } from 'utils'
import {
  FavouriteList,
  InactiveList,
  MyOpportunity,
} from './components/OpportunityList'

const VolunteerOpportunities = () => {
  const [searchText, setSearchText] = useState(null)
  const [sortSwitchValue, setSortSwitchValue] = useState(false)
  const [sortKey, setSortKey] = useState('createdAt')
  const [showEmbedCode, setShowEmbedCode] = useState(false)
  const { organization } = useAuthSelector()

  const { Title } = Typography

  const heading = 'Volunteer Opportunities'
  const optionList = {
    my: <MyOpportunity searchText={searchText} sortKey={sortKey} />,
    inactive: <InactiveList searchText={searchText} sortKey={sortKey} />,
    favorite: <FavouriteList searchText={searchText} sortKey={sortKey} />,
  }
  const createButtonLink = '/settings/create-volunteer-opportunities'

  const sortFilterData = [
    {
      label: 'Alphabetically',
      value: 'title',
      showOn: ['all', 'my'],
    },
    {
      label: 'Newest First',
      value: 'createdAt',
      showOn: ['all', 'my'],
    },
    {
      label: 'By Favorite Date',
      value: 'favDate',
      showOn: ['favorite'],
    },
  ]

  return (
    <>
      <ComponentView
        heading={heading}
        optionList={optionList}
        type="volunteer"
        createButtonLink={createButtonLink}
        setSearchText={setSearchText}
        sortFilterData={sortFilterData}
        sortKey={sortKey}
        setSortKey={setSortKey}
        sortSwitchValue={sortSwitchValue}
        setSortSwitchValue={setSortSwitchValue}
        extraButtons={[
          {
            label: 'Copy Calendar Embed Code',
            onClick: () => {
              setShowEmbedCode(true)
            },
          },
        ]}
      />
      <Modal
        centered
        title="Embed URL"
        width={600}
        open={showEmbedCode}
        onCancel={() => setShowEmbedCode(false)}
        footer={null}
      >
        <div>
          <div className="t-my-2">
            <Title level={4}>Copy iframe code</Title>
            <CopyBlock
              language="html"
              text={`<iframe
              style="width: 100%; height: 100%"
              src="${getVolunteerLandingPageUrl(
                organization?.OrgDomain,
              )}?embed=true&calendar=true"
              title="${organization?.Name}"
              ></iframe>`}
              theme={dracula}
              wrapLines
              codeBlock
            />
          </div>
          <div className="t-my-2">
            <Title level={4}>Copy code to paste in the website</Title>
            <CopyBlock
              language="html"
              text={htmlCode(
                `${getVolunteerLandingPageUrl(
                  organization?.OrgDomain,
                )}?embed=true&calendar=true`,
                'Opportunities Calendar',
              )}
              theme={dracula}
              wrapLines
              codeBlock
            />
          </div>
        </div>
      </Modal>
    </>
  )
}

export { VolunteerOpportunities }
